import { useSelector } from 'react-redux';
import Input from 'components/Input';
import { regexSelectors } from 'redux/selectors/config';
import { useTranslateByProject } from 'hooks/translation-hooks';

const CaseReference = ({ register, error, formErrors, label, placeholder }) => {
  const t = useTranslateByProject();
  const name = 'caseReference';
  const formName = 'case_reference';
  const caseReferencePattern = useSelector(regexSelectors)?.case_reference;

  return (
    <Input
      {...register(name, {
        required: true,
        setValueAs: v => {
          return v.toUpperCase();
        },
        pattern: new RegExp(
          caseReferencePattern?.regex,
          caseReferencePattern?.flag || 'i',
        ),
      })}
      autoComplete="off"
      label={t(label || formName)}
      error={error || (formErrors[name] && `${formName}_error_format`)}
      placeholder={t(placeholder || `${formName}-placeholder`)}
      testId="case_reference"
    />
  );
};

export default CaseReference;
